import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.min.css';
import { Card, CardBody, CardTitle } from 'reactstrap';

const ManageItinerary = () => {
  const [itineraries, setItineraries] = useState([]);
  const [locations, setLocations] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchLocations()
    fetchItineraries();
  }, []);

  useEffect(() => {
    if (itineraries.length) {
      $('#itineraryTable').DataTable();
    }
  }, [itineraries]);

  const fetchItineraries = async () => {
    try {
      const response = await api.get('/itinerary/get-all/3');
      setItineraries(response.data.data);
    } catch (error) {
      console.error('Error fetching itinerary data:', error);
    }
  };

  const fetchLocations = async () => {
    try {
      const response = await api.get('/location/get-all');
      setLocations(response.data.data);
    } catch (error) {
      console.error('Error fetching locations:', error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/itineraries/${id}`);
      setItineraries(itineraries.filter(itinerary => itinerary.id !== id));
      alert(`Itinerary with ID ${id} deleted successfully`);
    } catch (error) {
      console.error('Error deleting itinerary:', error);
      alert('Error deleting itinerary');
    }
  };

  const handleCreateItineraryClick = () => {
    navigate('/create-itinerary');
  };

  return (
    <div className='container mt-3 mb-5'>
      <CardTitle tag='h5' className='mb-3'> Itinerary List </CardTitle>
      <Card>
        <CardBody>
          <div>
            <button className='btn btn-success btn-sm create-button' onClick={handleCreateItineraryClick}>
              <FaPlus className='me-2' />
              Add Itinerary
            </button>
          </div>
          <table id="itineraryTable" className='table table-bordered dataTable no-footer'>
            <thead>
              <tr>
                <th>Sr No.</th>
                {/* <th>Package Name</th> */}
                <th>Location</th>
                <th>Date</th>
                <th>Image</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {itineraries?.map((itinerary, index) => (
                <tr key={itinerary.id}>
                  <td>{index + 1}</td>
                  {/* <td>{itinerary.card.category.name}/{itinerary.card.vendor.name}</td> */}
                  <td>{locations.filter((location) => location.id === itinerary.location_id)[0]?.location}</td>
                  <td>{itinerary.date}</td>
                  <td>
                    <img
                      style={{ width: '100px', objectFit: 'cover', borderRadius: '5px' }}
                      src={`${process.env.REACT_APP_IMAGE_BASE_URL}${locations.filter((location) => location.id === itinerary.location_id)[0]?.image_path}?${new Date().getTime()}`}
                      alt="location_image"
                      key={itinerary.id}
                    />
                  </td>
                  <td className='text-center align-middle'>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                      <FaEdit style={{ cursor: 'pointer', color: '#34c38f' }} onClick={() => navigate(`/update-itinerary/${itinerary.id}`)} />
                      <FaTrash style={{ cursor: 'pointer', color: 'red' }} onClick={() => handleDelete(itinerary.id)} />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </CardBody>
      </Card>
    </div>
  );
};

export default ManageItinerary;
